import styled from 'styled-components';
import type {ActivityTimelineItem_activity$key} from './__generated__/ActivityTimelineItem_activity.graphql';
import {TicketDescription} from './TicketDescription';
import {RecentActivityPreview} from './RecentActivityPreview';

const Divider = styled.div`
	border-top: 1px solid ${p => p.theme.sys.color.border.decorative};
`;

interface Props {
	description: string | null;
	timeline: readonly ActivityTimelineItem_activity$key[];
	onNavigateToActivity: () => void;
	/** Passed through so an inbound email can name its sender. */
	requesterEmail?: string;
}

/**
 * The overview: what the ticket says, then what has happened lately.
 *
 * Deliberately short. The AI reading sits above the tab bar because it belongs to
 * the ticket rather than to one tab, the editable fields live in the Details panel,
 * and the composer lives in Stream with the conversation it joins — so nothing here
 * competes with the description.
 */
export function OverviewTab({description, timeline, onNavigateToActivity, requesterEmail}: Props) {
	return (
		<>
			<TicketDescription description={description} />
			<Divider data-testid="overview-divider" />
			<RecentActivityPreview entries={timeline} onViewAll={onNavigateToActivity} requesterEmail={requesterEmail} />
		</>
	);
}
